import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ProductContext } from "../../Contexts/ProductContext";
import { CartCard } from "../../Component/CartCard/CartCard";
import { CartPrice } from "../../Component/CartPrice/CartPrice";
// import { CouponModel } from "../../Component/CouponModel/CouponModel";
import "./CartStyle.css";
import { updateCartItems } from "../../Utils/cartUtils";
import { AuthContext } from "../../Contexts/AuthContext";
import { printDebugLog } from "../../Utils/utils";
import { CouponModel } from "../CouponModel/CouponModel";

const Cart = () => {
  const { authState, setLoader } = useContext(AuthContext);
  const { orderState, productState, productDispatch, orderDispatch, verifyCoupon } = useContext(ProductContext);
  const { cartIds, cart } = productState;
  const [couponModel, setCouponModel] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    printDebugLog("Cart Component Rendered", cart);
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    printDebugLog("Cart", cartIds);
    updateCartItems(cartIds, cart, authState?.mobile, setLoader, productDispatch, orderDispatch);
  }, [cartIds, cart, authState?.mobile])

  return (
    <>
      {cart?.length === 0 ? (
        <div className="empty-cart">
          <h1>Your Cart is Empty!🙁</h1>
          <p>
            Don't worry, we have a stunning collection of watches waiting for
            you.
          </p>
          <button onClick={() => navigate("/products")}>Explore Watches</button>
        </div>
      ) : (
        <div className="cart-page-container">
          <h1 className="cart-heading">Cart ({cart?.length})</h1>
          <div className="cart-container">
            <div className="cart-card-container">
              {cart.map((product) => (
                <CartCard key={product?.prdId} product={product} />
              ))}
            </div>
            <div className="cart-price-container">
              <CartPrice setCouponModel={setCouponModel} />
            </div>
            {couponModel && <CouponModel
              couponValue={orderState?.coupon ?? ""}
              setCouponModel={setCouponModel}
              handleVerifyCoupon={(val) => verifyCoupon(val)}
            />
            }
          </div>
        </div>
      )}
    </>
  );
};
export { Cart };
